module.exports = __webpack_public_path__ + "img/account-new-icon4.4af9f907.svg";